import * as React from "react";
import Button from "../../Generics/Button";
import { style } from "typestyle";

interface IDropdownOption {
  label: string;
  onClick: () => void;
  className?: string;
}
interface IDropdownProps {
  label: string;
  icon: React.JSX.Element;
  className?: string;
  options: IDropdownOption[];
}
interface IDropdownState {
  isOpened: boolean;
}
class Dropdown extends React.Component<IDropdownProps, IDropdownState> {
  public state = { isOpened: false };

  public render() {
    return (
      <div
        onBlur={() => {
          this.closeDropdown();
        }}
        onClick={() => {
          this.toggleDropdown();
        }}
        tabIndex={0}
        className={style({ width: "100%" })}
      >
        {this.renderContent()}
        <Button
          stretched
          type="primary"
          label={this.props.label}
          icon={this.props.icon}
          className={this.props.className || ""}
          onClick={() => this.toggleDropdown()}
        />
      </div>
    );
  }

  private renderContent() {
    if (!this.state.isOpened) {
      return null;
    }

    return (
      <div
        className={style({
          background: "#fff",
          borderRadius: "8px",
          position: "absolute",
          bottom: "60px",
          boxShadow: "0 0 8px 0 rgba(0,0,0,0.12), 0 8px 8px 0 rgba(0,0,0,0.24)",
          fontSize: "14px",
          fontWeight: "normal",
          minWidth: "calc(100% - 24px)",
          cursor: "pointer",
          whiteSpace: "nowrap",
          $nest: {
            "&>div": {
              padding: "12px",
              borderBottom: "1px solid #E5E5E5",
            },
            "&>div:last-child": {
              borderBottom: "none",
            },
          },
        })}
      >
        {this.props.options.map(({ label, onClick, className }, i) => (
          <div
            key={i}
            className={className || ""}
            // A little cheat. onmousedown event fires before onblur.
            // Thus we can catch click on this element.
            onMouseDown={() => {
              this.closeDropdown();
              onClick();
            }}
          >
            {label}
          </div>
        ))}
      </div>
    );
  }

  private closeDropdown() {
    this.setState({ isOpened: false });
  }

  private toggleDropdown() {
    this.setState({ isOpened: !this.state.isOpened });
  }
}

export default Dropdown;
